/**
 * The journey reducer to handle the journey state - transaction and control
 * @param {Object} initialState The initial state
 * @returns {JSON} New state
 */
const createJourneyReducer = (initialState = {}) => {
    return (state = initialState, action) => {
        switch (action.type) {
            /**
             * action.data contains all of the journey related state:
             *  - transaction
             *  - form (not used here)
             *  - control
             */
            case 'SET_JOURNEY_PAYLOAD': {
                return state.merge({
                    transaction: action.payload.transaction,
                    control: action.payload.control
                });
            }
            case 'SET_OFFER_DETAILS': {
                // required for RPO
                const offersFromPayload = action.payload.map((offer) => ({ offer }));
                return state.setIn(['offers'], offersFromPayload);
            }
            case 'OFFER_SHOWN': {
                return state;
            }
            case 'SET_JOURNEY_STEP': {
                // required for energy
                return state.setIn(['transaction', 'step'], action.value);
            }

            default: {
                return state;
            }
        }
    };
};

export { createJourneyReducer };
